export interface VenueDetail {
  id: string;
  name: string;
  category: string;
  categorySlug: string;
  rating: number;
  reviews: number;
  distanceKm: number;
  image: string;
  address: string;
  district: string;
  isSponsored: boolean;
  isEditorPick: boolean;
  isOpen: boolean;
  description: string;
  phone: string;
  tags: string[];
  createdOrder: number;
}

export const allVenues: VenueDetail[] = [
  // ── TARİHİ YERLER ──────────────────────────────────────────────
  {
    id: "ulu-cami",
    name: "Ulu Cami",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.9,
    reviews: 3240,
    distanceKm: 1.2,
    image: "https://public.readdy.ai/ai/img_res/a629d5036105f764d218c5eca4d0a5c5.jpg",
    address: "Atatürk Cad., Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "20 kubbesi ve muhteşem hat yazıları ile Osmanlı mimarisinin en önemli eserlerinden biri. İçindeki şadırvan Bursa'nın simgesidir.",
    phone: "+90 224 221 0000",
    tags: ["Cami", "Mimari", "UNESCO", "Ücretsiz"],
    createdOrder: 1,
  },
  {
    id: "yesil-cami",
    name: "Yeşil Cami",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.8,
    reviews: 2100,
    distanceKm: 2.1,
    image: "https://readdy.ai/api/search-image?query=Yesil%20Cami%20Green%20Mosque%20Bursa%20Ottoman%20turquoise%20tiles%20minaret%20exterior%20stone%20architecture%20ancient%20Islamic%20heritage&width=600&height=400&seq=all_hist02&orientation=landscape",
    address: "Yeşil Mah., Yıldırım, Bursa",
    district: "Yıldırım",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "Türk-İslam mimarisinin şaheseri. Türkuaz çinileri ve zarif minaresiyle Bursa'nın simge yapısı.",
    phone: "+90 224 327 0000",
    tags: ["Cami", "Çini", "Mimari", "Ücretsiz"],
    createdOrder: 2,
  },
  {
    id: "yesil-turbe",
    name: "Yeşil Türbe",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.8,
    reviews: 1980,
    distanceKm: 2.3,
    image: "https://readdy.ai/api/search-image?query=Yesil%20Turbe%20Green%20Mausoleum%20Bursa%20ornate%20turquoise%20tiles%20geometric%20patterns%20Ottoman%20interior%20ancient%20serene%20atmosphere&width=600&height=400&seq=all_hist03&orientation=landscape",
    address: "Yeşil Mah., Yıldırım, Bursa",
    district: "Yıldırım",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "6 asırdır değişmeyen turkuaz çinileriyle nefes kesen Osmanlı türbesi. Sultan Mehmed I burada yatmaktadır.",
    phone: "+90 224 327 1111",
    tags: ["Türbe", "Çini", "Tarih", "Ücretsiz"],
    createdOrder: 3,
  },
  {
    id: "osman-gazi-turbesi",
    name: "Osman Gazi Türbesi",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.7,
    reviews: 1560,
    distanceKm: 1.8,
    image: "https://readdy.ai/api/search-image?query=Osman%20Gazi%20Tomb%20Bursa%20Ottoman%20dynasty%20founder%20mausoleum%20ancient%20stone%20historical%20landmark%20majestic%20architecture&width=600&height=400&seq=all_hist04&orientation=landscape",
    address: "Tophane, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Osmanlı Devleti'nin kurucusu Osman Gazi'nin türbesi. İmparatorluğun başlangıcını hissedebileceğiniz manevi bir mekan.",
    phone: "+90 224 220 0000",
    tags: ["Türbe", "Osmanlı", "Tarih", "Ücretsiz"],
    createdOrder: 4,
  },
  {
    id: "hanlar-bolgesi",
    name: "Hanlar Bölgesi",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.8,
    reviews: 2890,
    distanceKm: 0.9,
    image: "https://readdy.ai/api/search-image?query=Bursa%20covered%20bazaar%20hans%20Ottoman%20caravanserai%20historic%20stone%20arcade%20market%20traders%20ancient%20commercial%20district%20warm%20light&width=600&height=400&seq=all_hist05&orientation=landscape",
    address: "Kapalı Çarşı Çevresi, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "15. yüzyıldan kalma tarihi hanlar, kervansaraylar ve el sanatları atölyeleri. Osmanlı ticaret hayatının yaşayan müzesi.",
    phone: "",
    tags: ["Çarşı", "Han", "Alışveriş", "Kültür"],
    createdOrder: 5,
  },
  {
    id: "muradiye-camii",
    name: "Muradiye Camii & Külliyesi",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.7,
    reviews: 1240,
    distanceKm: 2.5,
    image: "https://readdy.ai/api/search-image?query=Muradiye%20mosque%20complex%20Bursa%20Ottoman%20stone%20architecture%20garden%20mausoleum%20historic%20peaceful%20complex%20Turkey&width=600&height=400&seq=all_hist06&orientation=landscape",
    address: "Muradiye, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "II. Murat dönemine ait cami ve külliyesi. Etrafındaki 12 türbe ile Osmanlı hanedan mirasını yansıtır.",
    phone: "+90 224 222 0000",
    tags: ["Cami", "Külliye", "Türbe", "Ücretsiz"],
    createdOrder: 6,
  },
  {
    id: "bursa-kalesi",
    name: "Bursa Kalesi & Tophane Parkı",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.6,
    reviews: 980,
    distanceKm: 1.5,
    image: "https://readdy.ai/api/search-image?query=Bursa%20castle%20Tophane%20park%20historic%20walls%20panoramic%20view%20city%20ancient%20ramparts%20Ottoman%20fortress%20Turkey%20scenic&width=600&height=400&seq=all_hist07&orientation=landscape",
    address: "Tophane, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Bizans ve Osmanlı dönemi surları. Tophane Parkı'ndan şehrin muhteşem panoramik manzarası.",
    phone: "",
    tags: ["Kale", "Manzara", "Park", "Ücretsiz"],
    createdOrder: 7,
  },

  // ── LEZZET DURAKLARI ───────────────────────────────────────────
  {
    id: "kebapci-iskender",
    name: "Kebapçı İskender",
    category: "Lezzet Durakları",
    categorySlug: "food",
    rating: 4.8,
    reviews: 4120,
    distanceKm: 0.8,
    image: "https://readdy.ai/api/search-image?query=iskender%20kebab%20restaurant%20Bursa%20traditional%20Turkish%20food%20grilled%20lamb%20pide%20bread%20tomato%20sauce%20butter%20original%20historic%20interior%20warm&width=600&height=400&seq=all_food01&orientation=landscape",
    address: "Atatürk Cad. 60, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: true,
    isEditorPick: true,
    isOpen: true,
    description: "1867'de icat edilen orijinal İskender Kebap'ın beşiği. Aynı aile, aynı tarif, 157 yıldır.",
    phone: "+90 224 221 4615",
    tags: ["İskender", "Kebap", "Tarihi", "Öğle"],
    createdOrder: 8,
  },
  {
    id: "iskenderoglu",
    name: "İskenderoğlu",
    category: "Lezzet Durakları",
    categorySlug: "food",
    rating: 4.7,
    reviews: 3200,
    distanceKm: 1.1,
    image: "https://readdy.ai/api/search-image?query=Turkish%20kebab%20restaurant%20interior%20warm%20traditional%20Bursa%20authentic%20food%20dining%20atmosphere%20classic%20furniture&width=600&height=400&seq=all_food02&orientation=landscape",
    address: "İnönü Cad., Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Nesiller boyu aktarılan aile tarifi. Orijinal lezzeti tutturanlar arasında en popüler tercih.",
    phone: "+90 224 220 5050",
    tags: ["İskender", "Kebap", "Aile"],
    createdOrder: 9,
  },
  {
    id: "haci-bey",
    name: "Hacı Bey Restaurant",
    category: "Lezzet Durakları",
    categorySlug: "food",
    rating: 4.6,
    reviews: 2100,
    distanceKm: 1.4,
    image: "https://readdy.ai/api/search-image?query=modern%20Turkish%20restaurant%20Bursa%20elegant%20interior%20traditional%20cuisine%20contemporary%20setting%20warm%20tones%20dinner&width=600&height=400&seq=all_food03&orientation=landscape",
    address: "Altıparmak Cad., Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Modern ortamda geleneksel Bursa lezzetleri. Kalabalıktan kaçmak isteyenlerin tercihi.",
    phone: "+90 224 225 3030",
    tags: ["Modern", "İskender", "Meze", "Akşam"],
    createdOrder: 10,
  },
  {
    id: "cumalikizik-sofrasi",
    name: "Cumalıkızık Köy Sofrası",
    category: "Lezzet Durakları",
    categorySlug: "food",
    rating: 4.8,
    reviews: 1580,
    distanceKm: 12.3,
    image: "https://readdy.ai/api/search-image?query=traditional%20Turkish%20village%20breakfast%20spread%20Bursa%20stone%20house%20rustic%20wooden%20table%20eggs%20honey%20cheese%20bread%20organic%20farm%20morning&width=600&height=400&seq=all_food04&orientation=landscape",
    address: "Cumalıkızık, Yıldırım, Bursa",
    district: "Yıldırım",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "700 yıllık köyde taş ev sofrasında organik köy kahvaltısı. Hafta sonları uzun kuyruklar olur.",
    phone: "+90 224 372 0000",
    tags: ["Kahvaltı", "Köy", "Organik", "Hafta Sonu"],
    createdOrder: 11,
  },
  {
    id: "pideciler-carsisi",
    name: "Eski Pideciler Çarşısı",
    category: "Lezzet Durakları",
    categorySlug: "food",
    rating: 4.6,
    reviews: 1120,
    distanceKm: 0.6,
    image: "https://readdy.ai/api/search-image?query=Turkish%20pide%20restaurant%20traditional%20stone%20oven%20wood-fired%20flatbread%20Bursa%20local%20favorite%20authentic%20street%20food%20warm%20atmosphere&width=600&height=400&seq=all_food05&orientation=landscape",
    address: "Kapalı Çarşı Yanı, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Tahinli pide ve pideli köftenin en doğru adresi. Taş fırın ve nesilden nesile aktarılan lezzet.",
    phone: "+90 224 220 7070",
    tags: ["Pide", "Tahinli Pide", "Köfte", "Fırın"],
    createdOrder: 12,
  },
  {
    id: "uludag-kebap",
    name: "Uludağ Kebap Evi",
    category: "Lezzet Durakları",
    categorySlug: "food",
    rating: 4.5,
    reviews: 890,
    distanceKm: 2.8,
    image: "https://readdy.ai/api/search-image?query=kebab%20house%20restaurant%20Bursa%20Turkey%20casual%20dining%20grilled%20meat%20local%20food%20traditional%20wooden%20interior%20cozy&width=600&height=400&seq=all_food06&orientation=landscape",
    address: "Nilüfer Cad., Nilüfer, Bursa",
    district: "Nilüfer",
    isSponsored: false,
    isEditorPick: false,
    isOpen: false,
    description: "Bursa'nın Nilüfer yakasında geniş menü ve uygun fiyatlarıyla ünlü kebap lokantası.",
    phone: "+90 224 442 0000",
    tags: ["Kebap", "Fiyat Performans", "Aile"],
    createdOrder: 13,
  },
  {
    id: "hamdi-restaurant",
    name: "Hamdi Restaurant Bursa",
    category: "Lezzet Durakları",
    categorySlug: "food",
    rating: 4.5,
    reviews: 870,
    distanceKm: 3.2,
    image: "https://readdy.ai/api/search-image?query=upscale%20Turkish%20restaurant%20terrace%20garden%20Bursa%20view%20elegant%20dining%20local%20cuisine%20premium%20setting%20outdoor%20seating&width=600&height=400&seq=all_food07&orientation=landscape",
    address: "Yıldız Mah., Nilüfer, Bursa",
    district: "Nilüfer",
    isSponsored: true,
    isEditorPick: false,
    isOpen: true,
    description: "Bahçe terası ve şehir manzarasıyla premium Türk mutfağı deneyimi. Özel günler için ideal.",
    phone: "+90 224 445 5555",
    tags: ["Premium", "Bahçe", "Manzara", "Özel Gün"],
    createdOrder: 14,
  },

  // ── EĞLENCE ───────────────────────────────────────────────────
  {
    id: "extrempark",
    name: "Extrempark Bursa",
    category: "Eğlence",
    categorySlug: "entertainment",
    rating: 4.8,
    reviews: 1820,
    distanceKm: 8.2,
    image: "https://readdy.ai/api/search-image?query=Extrempark%20adventure%20park%20mountain%20sled%20zipline%20rope%20course%20forest%20Uludag%20Turkey%20summer%20outdoor%20activities%20fun%20panoramic&width=600&height=400&seq=all_ent01&orientation=landscape",
    address: "Odunluk, Atatürk Kent Ormanı No:17, 16110 Nilüfer/Bursa",
    district: "Osmangazi",
    isSponsored: true,
    isEditorPick: true,
    isOpen: true,
    description: "Dağ kızağı, dev salıncak, ipli parkurlar ve panoramik seyir terası. Avrupa standartlarında macera parkı.",
    phone: "+90 224 285 8585",
    tags: ["Macera", "Dağ Kızağı", "Aile", "Manzara"],
    createdOrder: 15,
  },
  {
    id: "hayvanat-bahcesi",
    name: "Bursa Hayvanat Bahçesi",
    category: "Eğlence",
    categorySlug: "entertainment",
    rating: 4.5,
    reviews: 1340,
    distanceKm: 6.8,
    image: "https://readdy.ai/api/search-image?query=zoo%20wildlife%20park%20Bursa%20Turkey%20families%20children%20nature%20animals%20outdoor%20walkways%20green%20trees%20fun%20day%20trip&width=600&height=400&seq=all_ent02&orientation=landscape",
    address: "Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "200'den fazla tür barındıran modern hayvanat bahçesi. Çocuklu aileler için tam gün eğlence.",
    phone: "+90 224 260 0000",
    tags: ["Hayvanat", "Çocuk", "Aile", "Doğa"],
    createdOrder: 16,
  },
  {
    id: "aqua-bursa",
    name: "Aqua Bursa Su Parkı",
    category: "Eğlence",
    categorySlug: "entertainment",
    rating: 4.4,
    reviews: 980,
    distanceKm: 8.5,
    image: "https://readdy.ai/api/search-image?query=water%20park%20aqua%20park%20slides%20pool%20summer%20fun%20Turkey%20outdoor%20resort%20holiday%20family%20children%20splashing&width=600&height=400&seq=all_ent03&orientation=landscape",
    address: "Nilüfer, Bursa",
    district: "Nilüfer",
    isSponsored: true,
    isEditorPick: false,
    isOpen: true,
    description: "Yaz aylarının gözdesi. 20+ kaydırak, dalga havuzu ve tembel nehir ile tam bir yaz günü.",
    phone: "+90 224 452 0000",
    tags: ["Su Parkı", "Yaz", "Çocuk", "Havuz"],
    createdOrder: 17,
  },
  {
    id: "bursa-panoramik",
    name: "Panoramik Bursa Tesis",
    category: "Eğlence",
    categorySlug: "entertainment",
    rating: 4.6,
    reviews: 760,
    distanceKm: 22.0,
    image: "https://readdy.ai/api/search-image?query=mountain%20panoramic%20viewpoint%20terrace%20Bursa%20Turkey%20sunset%20city%20view%20restaurant%20cafe%20sky%20outdoor%20seating%20dramatic%20landscape&width=600&height=400&seq=all_ent04&orientation=landscape",
    address: "Uludağ, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Uludağ eteklerinde şehri ayaklarınızın altında görebileceğiniz seyir terası ve kafe.",
    phone: "+90 224 285 0000",
    tags: ["Manzara", "Kafe", "Terasa", "Fotoğraf"],
    createdOrder: 18,
  },
  {
    id: "citypark-sinema",
    name: "CityPark AVM & Sinema",
    category: "Eğlence",
    categorySlug: "entertainment",
    rating: 4.3,
    reviews: 540,
    distanceKm: 5.2,
    image: "https://readdy.ai/api/search-image?query=modern%20shopping%20mall%20cinema%20complex%20Bursa%20Turkey%20interior%20contemporary%20design%20entertainment%20center%20leisure&width=600&height=400&seq=all_ent05&orientation=landscape",
    address: "Nilüfer, Bursa",
    district: "Nilüfer",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "8 salonlu sinema, bowling, yemek katı ve alışveriş imkânı. Her yaşa hitap eden eğlence merkezi.",
    phone: "+90 224 441 0000",
    tags: ["Sinema", "AVM", "Bowling", "Yemek"],
    createdOrder: 19,
  },

  // ── KONAKLAMA ─────────────────────────────────────────────────
  {
    id: "gumusçpala-termal",
    name: "Gümüşpala Termal Hotel",
    category: "Konaklama",
    categorySlug: "accommodation",
    rating: 4.7,
    reviews: 892,
    distanceKm: 3.8,
    image: "https://readdy.ai/api/search-image?query=luxury%20thermal%20spa%20hotel%20Bursa%20Cekirge%20elegant%20exterior%20pool%20warm%20stone%20architecture%20wellness%20serene%20outdoor%20Turkey&width=600&height=400&seq=all_acc01&orientation=landscape",
    address: "Çekirge Cad. 1, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: true,
    isEditorPick: false,
    isOpen: true,
    description: "Osmanlı hamamı estetiği, mineral zengini termal sular ve şehrin en prestijli restoran deneyimi.",
    phone: "+90 224 233 9310",
    tags: ["Termal", "5 Yıldız", "Spa", "Restoran"],
    createdOrder: 20,
  },
  {
    id: "kervansaray-termal",
    name: "Kervansaray Termal Hotel",
    category: "Konaklama",
    categorySlug: "accommodation",
    rating: 4.6,
    reviews: 1240,
    distanceKm: 4.1,
    image: "https://readdy.ai/api/search-image?query=historic%20thermal%20hotel%20Ottoman%20architecture%20Bursa%20stone%20facade%20traditional%20luxury%20wellness%20heritage%20building%20restored&width=600&height=400&seq=all_acc02&orientation=landscape",
    address: "Çekirge Meyданı, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Tarihi Çekirge'de doğal termal sularla muhteşem bir konaklama deneyimi. Türk hamamı ve spa dahil.",
    phone: "+90 224 233 9300",
    tags: ["Termal", "4 Yıldız", "Hamam", "Tarihi"],
    createdOrder: 21,
  },
  {
    id: "hilton-bursa",
    name: "Hilton Garden Inn Bursa",
    category: "Konaklama",
    categorySlug: "accommodation",
    rating: 4.5,
    reviews: 1680,
    distanceKm: 4.8,
    image: "https://readdy.ai/api/search-image?query=Hilton%20hotel%20modern%20business%20Bursa%20Turkey%20exterior%20architecture%20city%20center%20premium%20lobby%20indoor%20pool%20contemporary&width=600&height=400&seq=all_acc03&orientation=landscape",
    address: "Akademi Cad., Nilüfer, Bursa",
    district: "Nilüfer",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "İş ve tatil seyahatleri için modern konfor. Kapalı yüzme havuzu, fitness merkezi ve tam donanımlı konferans salonları.",
    phone: "+90 224 219 1600",
    tags: ["5 Yıldız", "İş", "Havuz", "Konferans"],
    createdOrder: 22,
  },
  {
    id: "boutique-1453",
    name: "Boutique Hotel 1453",
    category: "Konaklama",
    categorySlug: "accommodation",
    rating: 4.8,
    reviews: 540,
    distanceKm: 1.6,
    image: "https://readdy.ai/api/search-image?query=boutique%20hotel%20restored%20Ottoman%20house%20Bursa%20historical%20center%20intimate%20cozy%20warm%20interior%20design%20unique%20rooms%20courtyard&width=600&height=400&seq=all_acc04&orientation=landscape",
    address: "Tophane, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "Osmanlı konağından dönüştürülmüş butik otel. 12 özel tasarım oda, el yapımı mobilyalar ve sabah kahvaltısı.",
    phone: "+90 224 224 1453",
    tags: ["Butik", "Tarihi", "Özel", "Kahvaltı"],
    createdOrder: 23,
  },
  {
    id: "goynuk-termal",
    name: "Göynük Termal Resort",
    category: "Konaklama",
    categorySlug: "accommodation",
    rating: 4.4,
    reviews: 380,
    distanceKm: 45.0,
    image: "https://readdy.ai/api/search-image?query=thermal%20resort%20nature%20valley%20Turkey%20forest%20mountain%20retreat%20wellness%20hotel%20outdoor%20pool%20serene%20landscape%20green&width=600&height=400&seq=all_acc05&orientation=landscape",
    address: "Göynük, Karacabey, Bursa",
    district: "Karacabey",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Doğanın içinde termal sular, organik tarım ve huzurlu bir kaçış. Şehrin gürültüsünden uzak hafta sonu tatili.",
    phone: "+90 224 676 0000",
    tags: ["Termal", "Doğa", "Hafta Sonu", "Huzur"],
    createdOrder: 24,
  },
  {
    id: "cumalikizik-butik",
    name: "Cumalıkızık Butik Otel",
    category: "Konaklama",
    categorySlug: "accommodation",
    rating: 4.7,
    reviews: 320,
    distanceKm: 12.5,
    image: "https://readdy.ai/api/search-image?query=Ottoman%20village%20boutique%20guesthouse%20stone%20house%20Cumalikizik%20Bursa%20Turkey%20cozy%20rustic%20charm%20authentic%20traditional%20rooms&width=600&height=400&seq=all_acc06&orientation=landscape",
    address: "Cumalıkızık, Yıldırım, Bursa",
    district: "Yıldırım",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "700 yıllık taş konakta konaklama deneyimi. Sabah köyde uyanmak bambaşka bir his.",
    phone: "+90 224 372 1111",
    tags: ["Butik", "Köy", "Tarihi", "Özgün"],
    createdOrder: 25,
  },

  // ── DOĞA VE ROTALAR ───────────────────────────────────────────
  {
    id: "bursa-teleferik",
    name: "Bursa Teleferik",
    category: "Doğa ve Rotalar",
    categorySlug: "nature",
    rating: 4.7,
    reviews: 1450,
    distanceKm: 8.2,
    image: "https://readdy.ai/api/search-image?query=cable%20car%20Uludag%20mountain%20Bursa%20Turkey%20aerial%20gondola%20panoramic%20view%20lush%20green%20forest%20city%20below%20scenic%20adventure&width=600&height=400&seq=all_nat01&orientation=landscape",
    address: "Namazgah, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "Dünyanın en uzun teleferik hatlarından biri. Şehirden Uludağ zirvesine 8 dakikalık panoramik yolculuk.",
    phone: "+90 224 254 5060",
    tags: ["Teleferik", "Manzara", "Doğa", "Yaz/Kış"],
    createdOrder: 26,
  },
  {
    id: "botanik-park",
    name: "Bursa Botanik Parkı",
    category: "Doğa ve Rotalar",
    categorySlug: "nature",
    rating: 4.6,
    reviews: 720,
    distanceKm: 4.5,
    image: "https://readdy.ai/api/search-image?query=botanical%20garden%20Bursa%20Turkey%20lush%20greenery%20lake%20pathways%20families%20picnic%20outdoor%20urban%20park%20serene%20nature%20spring&width=600&height=400&seq=all_nat02&orientation=landscape",
    address: "Çekirge, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: true,
    isEditorPick: false,
    isOpen: true,
    description: "Şehir merkezinde yürüyüş, bisiklet ve piknik alanlarıyla yeşil nefes noktası. Gölet kenarı kafeler mevcut.",
    phone: "+90 224 260 1111",
    tags: ["Park", "Yürüyüş", "Piknik", "Bisiklet"],
    createdOrder: 27,
  },
  {
    id: "uludag-milli-park",
    name: "Uludağ Milli Parkı",
    category: "Doğa ve Rotalar",
    categorySlug: "nature",
    rating: 4.8,
    reviews: 2100,
    distanceKm: 26.0,
    image: "https://readdy.ai/api/search-image?query=Uludag%20national%20park%20Bursa%20Turkey%20mountain%20forest%20snow%20peaks%20hiking%20trails%20winter%20skiing%20dramatic%20landscape%20Turkey&width=600&height=400&seq=all_nat03&orientation=landscape",
    address: "Uludağ, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "Türkiye'nin en ünlü dağı ve milli parkı. Yaz yürüyüşü, kış kayağı ve nefes kesen doğa manzaraları.",
    phone: "+90 224 285 2100",
    tags: ["Milli Park", "Kayak", "Yürüyüş", "Doğa"],
    createdOrder: 28,
  },
  {
    id: "golyazi",
    name: "Gölyazı Köyü",
    category: "Doğa ve Rotalar",
    categorySlug: "nature",
    rating: 4.7,
    reviews: 890,
    distanceKm: 28.0,
    image: "https://readdy.ai/api/search-image?query=Golyazi%20village%20lake%20Bursa%20Turkey%20ancient%20stone%20houses%20peninsula%20water%20reflection%20serene%20peaceful%20Ottoman%20ruins%20boats&width=600&height=400&seq=all_nat04&orientation=landscape",
    address: "Gölyazı, Nilüfer, Bursa",
    district: "Nilüfer",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Uluabat Gölü üzerindeki yarımadada saklı antik köy. Balıkçı tekneleri, taş evler ve muhteşem göl manzarası.",
    phone: "",
    tags: ["Göl", "Köy", "Fotoğraf", "Huzur"],
    createdOrder: 29,
  },
  {
    id: "karacabey-longozu",
    name: "Karacabey Longozu",
    category: "Doğa ve Rotalar",
    categorySlug: "nature",
    rating: 4.6,
    reviews: 560,
    distanceKm: 55.0,
    image: "https://readdy.ai/api/search-image?query=Karacabey%20longos%20flooded%20forest%20Turkey%20wetland%20lake%20birds%20wildlife%20canoe%20nature%20reserve%20ancient%20trees%20reflection%20water&width=600&height=400&seq=all_nat05&orientation=landscape",
    address: "Karacabey, Bursa",
    district: "Karacabey",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Avrupa'nın sayılı longoz ormanlarından biri. Su içinde yükselen devasa ağaçlar ve kuş gözlem imkânı.",
    phone: "+90 224 676 1000",
    tags: ["Longoz", "Kuş Gözlemi", "Doğa", "Kano"],
    createdOrder: 30,
  },

  // ── GEZİLECEK YERLER ─────────────────────────────────────────
  {
    id: "cumalikizik-koy",
    name: "Cumalıkızık Köyü",
    category: "Gezilecek Yerler",
    categorySlug: "sightseeing",
    rating: 4.9,
    reviews: 2580,
    distanceKm: 12.0,
    image: "https://readdy.ai/api/search-image?query=Cumalikizik%20village%20Bursa%20Turkey%20UNESCO%20cobblestone%20street%20stone%20house%20ancient%20Ottoman%20village%20charming%20narrow%20alley%20morning%20light&width=600&height=400&seq=all_sight01&orientation=landscape",
    address: "Cumalıkızık, Yıldırım, Bursa",
    district: "Yıldırım",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "UNESCO Dünya Mirası. 700 yıllık taş evler, dar sokaklar ve geleneksel yaşam. Fotoğraf tutkunlarının başucu yeri.",
    phone: "",
    tags: ["UNESCO", "Köy", "Fotoğraf", "Kahvaltı"],
    createdOrder: 31,
  },
  {
    id: "kapali-carsi",
    name: "Bursa Kapalı Çarşısı",
    category: "Gezilecek Yerler",
    categorySlug: "sightseeing",
    rating: 4.7,
    reviews: 2100,
    distanceKm: 0.7,
    image: "https://readdy.ai/api/search-image?query=Bursa%20covered%20bazaar%20grand%20market%20Ottoman%20architecture%20stone%20vaulted%20ceiling%20shops%20carpets%20textiles%20historic%20interior%20Turkey&width=600&height=400&seq=all_sight02&orientation=landscape",
    address: "Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "14. yüzyıldan beri alışverişin kalbi. İpekli kumaşlar, el dokuması halılar ve Bursa'ya özgü hediyelikler.",
    phone: "",
    tags: ["Çarşı", "Alışveriş", "Tarihi", "İpek"],
    createdOrder: 32,
  },
  {
    id: "bursa-muzesi",
    name: "Bursa Müzesi",
    category: "Gezilecek Yerler",
    categorySlug: "sightseeing",
    rating: 4.5,
    reviews: 1240,
    distanceKm: 1.3,
    image: "https://readdy.ai/api/search-image?query=Bursa%20archaeological%20museum%20Ottoman%20artifacts%20ancient%20coins%20ceramics%20exhibits%20cultural%20heritage%20Turkey%20indoor%20modern%20display&width=600&height=400&seq=all_sight03&orientation=landscape",
    address: "Kültür Parkı İçi, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Roma, Bizans ve Osmanlı dönemlerine ait zengin koleksiyon. Bölgenin tarihi sürecini belgeleyen binlerce eser.",
    phone: "+90 224 234 0000",
    tags: ["Müze", "Arkeoloji", "Osmanlı", "Tarih"],
    createdOrder: 33,
  },
  {
    id: "kent-muzesi",
    name: "Bursa Kent Müzesi",
    category: "Gezilecek Yerler",
    categorySlug: "sightseeing",
    rating: 4.4,
    reviews: 670,
    distanceKm: 0.5,
    image: "https://readdy.ai/api/search-image?query=city%20museum%20Bursa%20modern%20exhibition%20interactive%20display%20historic%20urban%20life%20culture%20architecture%20interior%20gallery%20light&width=600&height=400&seq=all_sight04&orientation=landscape",
    address: "Atatürk Cad., Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: false,
    description: "Bursa'nın geçmişini interaktif sergilerle anlatan modern müze. Özellikle çocuklar için eğitici ve eğlenceli.",
    phone: "+90 224 220 5100",
    tags: ["Müze", "Modern", "Çocuk", "Eğitim"],
    createdOrder: 34,
  },
  {
    id: "mudanya-mutareke",
    name: "Mudanya Mütareke Evi",
    category: "Gezilecek Yerler",
    categorySlug: "sightseeing",
    rating: 4.3,
    reviews: 450,
    distanceKm: 30.0,
    image: "https://readdy.ai/api/search-image?query=Mudanya%20Armistice%20House%20museum%20historic%20Ottoman%20building%20sea%20view%20Turkey%20Bursa%20coast%20heritage%20landmark%20restored&width=600&height=400&seq=all_sight05&orientation=landscape",
    address: "Mudanya, Bursa",
    district: "Mudanya",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "1922 Mudanya Mütarekesi'nin imzalandığı tarihi bina. Kurtuluş Savaşı tarihine ilgi duyanlar için önemli durak.",
    phone: "+90 224 544 0000",
    tags: ["Müze", "Tarih", "Kurtuluş Savaşı", "Sahil"],
    createdOrder: 35,
  },
  {
    id: "nilüfer-imareti",
    name: "Nilüfer Hatun İmareti",
    category: "Gezilecek Yerler",
    categorySlug: "sightseeing",
    rating: 4.6,
    reviews: 890,
    distanceKm: 0.4,
    image: "https://readdy.ai/api/search-image?query=Nilufer%20Hatun%20Imaret%20Ottoman%20ethnography%20museum%20Bursa%20ancient%20stone%20architecture%20courtyard%20peaceful%20historic%20building%20Turkey&width=600&height=400&seq=all_sight06&orientation=landscape",
    address: "Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "14. yüzyıldan kalma imaret, günümüzde Türk-İslam Eserleri Müzesi olarak hizmet veriyor. Osmanlı gündelik yaşamına dair eserler.",
    phone: "+90 224 221 0000",
    tags: ["Müze", "İmaret", "Osmanlı", "Etnografya"],
    createdOrder: 36,
  },
];

export const DISTRICTS = ["Osmangazi", "Yıldırım", "Nilüfer", "Mudanya", "Karacabey", "Gemlik"];

export const CATEGORY_META: Record<string, { title: string; desc: string; icon: string; image: string; count: string }> = {
  historical: {
    title: "Tarihi Yerler",
    desc: "Osmanlı mirası, UNESCO alanları ve asırlık yapılar Bursa'nın tarihi ruhunu yansıtıyor.",
    icon: "ri-ancient-pavilion-line",
    image: "https://readdy.ai/api/search-image?query=Bursa%20Ottoman%20historical%20architecture%20grand%20mosque%20minaret%20stone%20ancient%20buildings%20heritage%20panoramic%20Turkey%20dramatic%20sky%20warm%20tones&width=1400&height=500&seq=catheader01&orientation=landscape",
    count: "120+ mekan",
  },
  food: {
    title: "Lezzet Durakları",
    desc: "İskender'in vatanı, pideli köftenin kalesi. Bursa'nın gastronomi dünyasına hoş geldiniz.",
    icon: "ri-restaurant-line",
    image: "https://readdy.ai/api/search-image?query=Bursa%20Turkish%20food%20market%20iskender%20kebab%20traditional%20cuisine%20restaurant%20street%20food%20warm%20inviting%20authentic%20gastronomy&width=1400&height=500&seq=catheader02&orientation=landscape",
    count: "85+ restoran",
  },
  entertainment: {
    title: "Eğlence",
    desc: "Macera, heyecan ve eğlence için Bursa'nın en popüler aktivite adresleri.",
    icon: "ri-gamepad-line",
    image: "https://readdy.ai/api/search-image?query=adventure%20park%20fun%20activities%20outdoor%20Bursa%20Turkey%20zipline%20mountain%20sled%20entertainment%20summer%20forest%20excitement&width=1400&height=500&seq=catheader03&orientation=landscape",
    count: "60+ mekan",
  },
  accommodation: {
    title: "Konaklama",
    desc: "Termal sulardan butik otellere, Bursa'da her bütçeye uygun konforlu konaklama seçenekleri.",
    icon: "ri-hotel-line",
    image: "https://readdy.ai/api/search-image?query=luxury%20hotel%20thermal%20spa%20Bursa%20Turkey%20elegant%20exterior%20wellness%20architecture%20premium%20accommodation%20stone%20warm%20tones&width=1400&height=500&seq=catheader04&orientation=landscape",
    count: "200+ seçenek",
  },
  nature: {
    title: "Doğa ve Rotalar",
    desc: "Uludağ'ın zirvesinden Gölyazı'nın göllerine uzanan nefes kesen doğa rotaları.",
    icon: "ri-plant-line",
    image: "https://readdy.ai/api/search-image?query=Uludag%20mountain%20Bursa%20Turkey%20forest%20nature%20landscape%20hiking%20trails%20green%20scenic%20panoramic%20peaks%20mist%20autumn&width=1400&height=500&seq=catheader05&orientation=landscape",
    count: "40+ rota",
  },
  sightseeing: {
    title: "Gezilecek Yerler",
    desc: "Tarihi çarşılardan müzelere, köylerden panoramik noktalara Bursa'nın görülmesi gereken yerleri.",
    icon: "ri-eye-line",
    image: "https://readdy.ai/api/search-image?query=Cumalikizik%20village%20cobblestone%20Ottoman%20houses%20sightseeing%20Bursa%20Turkey%20heritage%20tourism%20travel%20discover%20explore&width=1400&height=500&seq=catheader06&orientation=landscape",
    count: "95+ yer",
  },
  featured: {
    title: "Öne Çıkan Mekanlar",
    desc: "Editörlerimizin ve ziyaretçilerimizin en çok önerdiği, Bursa'nın en iyi adresleri.",
    icon: "ri-star-line",
    image: "https://readdy.ai/api/search-image?query=Bursa%20Turkey%20best%20places%20featured%20highlights%20editorial%20picks%20tourism%20landmarks%20panoramic%20scenic%20beautiful%20diverse&width=1400&height=500&seq=catheader07&orientation=landscape",
    count: "Editör seçimi",
  },
};
